var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-back"},[_c('button',{staticClass:"go-back__button",on:{"click":_vm.goBack}},[_c('img',{staticClass:"go-back__icon",attrs:{"src":require("@/assets/svg/icon-chevron-left.svg"),"alt":"Voltar"}}),_c('span',[_vm._v("Voltar")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }